import { render, staticRenderFns } from "./private-car.vue?vue&type=template&id=4bc0623a&scoped=true&"
import script from "./private-car.vue?vue&type=script&lang=js&"
export * from "./private-car.vue?vue&type=script&lang=js&"
import style0 from "./private-car.vue?vue&type=style&index=0&id=4bc0623a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc0623a",
  null
  
)

export default component.exports